import { useEffect, useRef, useState } from 'react';
import Webcam from 'react-webcam';
import jsQR from 'jsqr';
import { XMarkIcon } from '@heroicons/react/24/outline';

const videoConstraints = { facingMode: 'environment' };

function QrScannerModal({ onClose, onScan }) {
  const webcamRef = useRef(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    let frameId;

    const tick = () => {
      const video = webcamRef.current?.video;
      if (video && video.readyState === video.HAVE_ENOUGH_DATA) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, imageData.width, imageData.height);
        if (code?.data) {
          onScan(code.data);
          return;
        }
      }
      frameId = requestAnimationFrame(tick);
    };

    frameId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frameId);
  }, [onScan]);

  return (
    <div className="fixed inset-0 z-30 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" />
      <div className="relative w-full max-w-md bg-white rounded-lg shadow-xl overflow-hidden">
        <div className="flex items-center justify-between px-5 py-4 bg-[#3f6d8e]">
          <h2 className="text-lg font-semibold text-white">Scan LRN QR Code</h2>
          <button type="button" onClick={onClose} className="p-1 text-gray-200 hover:text-white">
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        <div className="p-5 space-y-3">
          {error ? (
            <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded px-3 py-2">{error}</p>
          ) : (
            <div className="relative rounded-md overflow-hidden bg-black aspect-square">
              <Webcam
                ref={webcamRef}
                audio={false}
                videoConstraints={videoConstraints}
                onUserMediaError={() => setError('Unable to access camera. Check permissions and try again.')}
                className="w-full h-full object-cover"
              />
              <div className="pointer-events-none absolute inset-8 border-2 border-white/80 rounded-lg" />
            </div>
          )}
          <p className="text-xs text-gray-500 text-center">
            Point the camera at the LRN QR code on the student's ID.
          </p>
        </div>
      </div>
    </div>
  );
}

export default QrScannerModal;
